import { render, staticRenderFns } from "./FixedHtmlRender.vue?vue&type=template&id=cf68fdfa&scoped=true&"
import script from "./FixedHtmlRender.vue?vue&type=script&lang=ts&"
export * from "./FixedHtmlRender.vue?vue&type=script&lang=ts&"
import style0 from "./FixedHtmlRender.vue?vue&type=style&index=0&id=cf68fdfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf68fdfa",
  null
  
)

export default component.exports